import React, { CSSProperties, ReactNode } from 'react';
import ReactMarkdown from 'react-markdown';
import LargeWidthContainer from '../LargeWidthContainer';
import MediumWidthContainer from '../MediumWidthContainer';
import styles from './headingAndTextContainer.module.scss';

interface ImageAndTextProps {
    heading?: string;
    h1?: boolean;
    ingressSize?: 'small' | 'big';
    paragraphSize?: 'small' | 'big';
    ingress?: string;
    markdown?: string;
    children?: ReactNode;
    largeContainer?: boolean;
    extraClassNames?: string;
    extraStyles?: CSSProperties;
}

const ImageAndTextContainer = ({
    h1 = false,
    ingressSize = 'small',
    ingress,
    paragraphSize = 'small',
    markdown,
    children,
    largeContainer = false,
    extraClassNames,
    extraStyles,
}: ImageAndTextProps) => {
    const ingressTitle = ingressSize === 'small' ? styles.ingressSmall : styles.ingressBig;
    const paragraph = paragraphSize === 'small' ? styles.paragraphSmall : styles.paragraphBig;

    const renderIngress = () => {
        if (h1) {
            return <h1 className={ingressTitle}>{ingress}</h1>;
        } else {
            return <h2 className={ingressTitle}>{ingress}</h2>;
        }
    };

    const renderContent = () => {
        return (
            <div className={`${styles.headingAndTextContainer}`}>
                <div className={`${styles.textContainer} ${styles.paddingRightLarge}`}>
                    {ingress ? renderIngress() : null}
                    {children ? <div className={paragraph}>{children}</div> : null}
                    {markdown ? (
                        <ReactMarkdown className={paragraph}>{markdown}</ReactMarkdown>
                    ) : null}
                </div>
            </div>
        );
    };

    if (largeContainer) {
        return (
            <LargeWidthContainer extraClassNames={extraClassNames} extraStyles={extraStyles}>
                {renderContent()}
            </LargeWidthContainer>
        );
    } else {
        return (
            <MediumWidthContainer extraClassNames={extraClassNames} extraStyles={extraStyles}>
                {renderContent()}
            </MediumWidthContainer>
        );
    }
};

export default ImageAndTextContainer;
